// Duration constants in milliseconds (from backend)
export const MIN_API_KEY_EXPIRY_MS = 60000; // 1 minute
export const DEFAULT_API_KEY_EXPIRY_MS = 3600000; // 1 hour
export const MAX_API_KEY_EXPIRY_MS = 3600000 * 24; // 1 day

// Duration constants in minutes (for user input)
export const MIN_API_KEY_EXPIRY_MINUTES = 1; // 1 minute
export const DEFAULT_API_KEY_EXPIRY_MINUTES = 60; // 1 hour
export const MAX_API_KEY_EXPIRY_MINUTES = 1440; // 24 hours / 1 day

/**
 * Converts minutes to milliseconds
 */
export function minutesToMs(minutes: number): number {
  return minutes * 60000;
}

/**
 * Converts milliseconds to minutes
 */
export function msToMinutes(milliseconds: number): number {
  return Math.round(milliseconds / 60000);
}

/**
 * Gets the default duration in minutes
 */
export function getDefaultDurationMinutes(): number {
  return DEFAULT_API_KEY_EXPIRY_MINUTES;
}
